<template>
    <v-container fluid>
        <center>
            <v-row>
                <v-col v-for="(project, index) in projects" :key="index" cols="12" sm="6" md="6">
                    <v-card class="project-card">
                        <v-img :src="project.image" class="white--text align-end" height="450px" width="700px">
                            <div class="overlay">
                                <v-card-title class="project-title">{{ project.title }}</v-card-title>
                                <div class="project-actions">
                                    <a :href="project.link" target="_blank" class="project-link">{{ project.linkText
                                        }}</a>
                                    <v-btn color="primary" small @click="openModal(project.title)">Bilgi Al</v-btn>
                                </div>
                            </div>
                        </v-img>
                    </v-card>
                </v-col>
            </v-row>
        </center>


        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline">Bilgi Al</span>
                </v-card-title>
                <v-card-text>
                    <v-form ref="form" v-model="valid">
                        <v-select v-model="selectedProject" :items="projectTitles"
                            label="Bilgi Alınması İstenilen Proje" required></v-select>
                        <v-text-field v-model="fullName" label="Ad Soyad" required></v-text-field>
                        <v-text-field v-model="phoneNumber" label="Telefon" required></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeModal">İptal</v-btn>
                    <v-btn color="blue darken-1" text @click="submit">Gönder</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';

import IlksmsImage from '@/assets/dashboard_sliders/ilksms-gorsel-700x450.png';
import KolaydernekImage from '@/assets/dashboard_sliders/kolaydernek-gorseli-700x450.png';
import SalonrandevuImage from '@/assets/dashboard_sliders/salonrandevu-gorsel-700x450.png';
import VayonetImage from '@/assets/dashboard_sliders/vayonet-gorseli-700x450.png';
import Swal from 'sweetalert2'

export default {
    data() {
        return {
            dialog: false,
            valid: false,
            selectedProject: '',
            fullName: '',
            phoneNumber: '',
            projects: [
                {
                    title: 'İlkSMS',
                    image: IlksmsImage,
                    link: 'https://ilksms.com',
                    linkText: 'www.ilksms.com'
                },
                {
                    title: 'Kolay Dernek',
                    image: KolaydernekImage,
                    link: 'https://kolaydernek.com',
                    linkText: 'www.kolaydernek.com'
                },
                {
                    title: 'Salon Randevu',
                    image: SalonrandevuImage,
                    link: 'https://salonrandevu.com',
                    linkText: 'www.salonrandevu.com'
                },
                {
                    title: 'Vayonet',
                    image: VayonetImage,
                    link: 'https://vayonet.com',
                    linkText: 'www.vayonet.com'
                },
                // Diğer projeler
            ],
        };
    },
    computed: {
        projectTitles() {
            return this.projects.map(project => project.title);
        }
    },
    methods: {
        ...mapActions({ send: 'sendBackend', sendAsync: 'asyncSender' }),
        openModal(projectTitle) {
            this.selectedProject = projectTitle;
            this.dialog = true;
        },
        closeModal() {
            this.dialog = false;
        },
        async submit() {
            if (this.$refs.form.validate()) {
                const payload = {   };
                payload.project = this.selectedProject;
                payload.name = this.fullName;
                payload.phone = this.phoneNumber;

                try {
                    this.send({ route: 'other-project', data: payload })
                        .then(async (res) => {
                            console.log(res);
                            if (res.status == "success") {
                                Swal.fire(
                                    'İlginiz için Teşekkür Ederiz!',
                                    'Talebiniz tarafımıza ulaşmıştır, Müşteri temsilciniz en kısa sürede size ulaşacaktır.',
                                    'success'
                                )
                            }
                        });
                } catch (error) {
                    // Hata mesajını kullanıcıya gösterebilirsiniz
                    Swal.fire(
                                    'Hata',
                                    'Bilgileriniz gönderilirken bir hata oluştu',
                                    'error'
                                )
                    this.$toast.error('');
                }

                this.closeModal();
            }
        }
    }
};
</script>

<style scoped>
.v-img {
    background-size: cover;
    background-position: center;
    width: 700px;
    /* Resim genişliği */
    height: 450px;
    /* Resim yüksekliği */
}

.project-card {
    position: relative;
    width: 700px;
    height: 450px;
}

.overlay {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
}

.project-title {
    font-size: 18px;
}

.project-actions {
    display: flex;
    align-items: center;
}

.project-link {
    color: white;
    text-decoration: none;
    margin-right: 10px;
}
</style>
